// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterFrontImage_root__2s9ST","title":"AfterFrontImage_title__l0Foo"};